import { render, staticRenderFns } from "./RebateDetailTable.vue?vue&type=template&id=fe12b60a&scoped=true&"
import script from "./RebateDetailTable.vue?vue&type=script&lang=js&"
export * from "./RebateDetailTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=fe12b60a&prod&scoped=true&lang=css&"
import style1 from "./RebateDetailTable.vue?vue&type=style&index=1&id=fe12b60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe12b60a",
  null
  
)

export default component.exports